export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.5-0956.10",
  commitId: "70828a4c44d9e0539ce85054500c270d82acde41",
  commitTime: "2026-10-05T09:56:10.000Z",
});
